var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdogwuVictoryBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 81,
    viewBox: "0 0 269 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.325 56.6743C264.325 55.2711 264.981 54.0434 265.928 52.9325C266.292 34.691 265.855 4.58079 265.855 4.58079C261.704 1.83287 27.113 -3.25371 6.28319 4.58079C6.28319 4.58079 3.51559 65.3858 6.93867 67.4906C10.3618 69.5954 263.379 70.4724 265.054 66.2628C265.345 65.5612 265.564 63.398 265.709 60.2993C264.835 59.2469 264.325 58.0191 264.325 56.6159V56.6743Z",
    fill: "url(#paint0_linear_4948_66295)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265.707 60.3582C265.561 63.4569 265.343 65.6202 265.052 66.3218C263.376 70.5314 10.3595 69.6544 6.93646 67.5496C3.51338 65.4448 6.28098 4.63977 6.28098 4.63977L1.61976 15.456C1.61976 15.456 -1.22067 76.2611 2.27524 78.3659C5.84399 80.4706 265.926 81.3476 267.674 77.1381C268.183 75.9103 268.475 70.239 268.62 62.8138C267.455 62.1122 266.435 61.2937 265.707 60.3582Z",
    fill: "#732200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.928 52.9915C266.657 52.1729 267.676 51.4129 268.696 50.8282C268.696 34.0484 268.477 15.456 268.477 15.456C268.113 15.2222 265.855 4.63977 265.855 4.63977C265.855 4.63977 266.292 34.75 265.928 52.9915Z",
    fill: "#732200"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.59
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.807 67.7245C23.393 69.5955 237.955 70.2971 262.717 66.906C265.121 69.4785 266.942 72.3434 267.961 75.676C267.889 76.3191 267.743 76.8453 267.67 77.0791C265.922 81.2887 5.84055 80.4117 2.2718 78.3069C2.19897 78.2485 2.0533 78.1315 1.98047 77.9561C3.21861 74.3312 5.18507 70.8817 7.807 67.6661V67.7245Z",
    fill: "#732200"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M21.939 41.1802C24.8523 41.8818 26.7459 43.9866 29.8777 44.5712C39.0544 46.3837 63.6715 34.515 70.372 41.8818C65.8565 42.6418 57.408 43.8112 54.2034 46.6175C51.5086 48.9562 52.1641 49.4824 55.5144 49.8916C57.7722 50.1255 60.8311 48.8977 63.016 48.43C68.3327 47.3191 73.6495 46.4421 79.1118 45.799C88.2886 44.7466 97.4654 44.6297 106.642 44.9805C119.024 45.5067 130.385 48.7808 142.33 51.061C146.627 51.8795 158.644 55.2706 162.722 52.9904C166.655 50.8271 161.63 51.2949 161.411 49.0147C160.902 44.2789 181.513 42.1156 185.009 41.6479C199.43 39.8354 214.142 39.777 228.635 40.8878C234.316 41.2971 238.103 43.168 243.42 44.2789C250.266 45.6821 257.695 43.8696 264.687 44.5127C264.905 44.5127 265.415 44.6297 265.998 44.8051C265.998 42.1741 265.998 39.4262 265.998 36.6783C262.21 36.6198 258.35 36.4444 254.417 35.9182C250.193 35.392 237.957 32.2933 234.243 33.755C243.274 30.1885 255 27.4991 265.925 26.8559C265.925 25.9205 265.925 25.0435 265.925 24.108C265.124 24.2249 264.25 24.3418 263.521 24.4003C252.888 25.6866 242.546 27.9083 232.349 30.5393C220.332 33.638 207.732 32.761 195.351 33.2872C185.737 33.6965 177.143 35.6843 168.331 38.4907C159.664 41.1802 151.506 45.5067 141.893 45.4482C133.153 45.3898 124.923 42.5249 116.183 41.9402C112.032 41.6479 86.1036 44.922 83.9915 41.5309C82.1707 38.6076 91.7117 37.3214 92.6585 35.0997C82.1707 31.2409 67.6044 33.3457 56.6797 34.515C51.7271 35.0412 36.3597 38.6077 34.466 32.878C41.822 34.2227 49.9063 31.0655 57.0438 29.7208C69.498 27.4406 81.2968 28.1422 93.751 30.1885C105.768 32.1764 117.785 34.8658 130.094 34.515C143.349 34.1642 156.605 32.2348 169.714 30.9486C182.46 29.6623 195.278 28.493 208.024 26.9728C218.948 25.6866 228.125 20.3661 238.831 18.2029C247.717 16.3904 256.748 15.2211 265.852 14.5195C265.852 10.7192 265.779 7.7374 265.779 6.10035C256.165 4.98948 246.479 4.22941 236.792 3.93707C223.682 3.58628 210.646 6.80195 197.754 4.05403C199.575 3.0601 201.687 2.30002 203.945 1.65689C193.239 1.36456 181.659 1.13072 169.641 0.955321C164.398 2.12465 159.227 3.29395 153.983 4.40482C134.464 8.73133 118.732 5.10643 100.233 0.955321C99.1405 0.721456 98.048 0.487599 96.9555 0.370667C91.7117 0.370667 86.6135 0.370634 81.5881 0.429101C70.2992 1.83229 59.156 5.34027 47.7214 5.6326C33.4464 5.9834 18.8801 3.76169 6.06174 9.6668C6.06174 10.0761 6.06174 10.4853 6.06174 10.9531C20.9922 4.6387 38.4718 8.78979 54.4947 7.32813C63.0889 6.56807 71.3188 4.17094 79.7673 2.88468C85.4482 2.00768 91.2019 1.59842 96.8099 2.88468C101.18 3.87861 105.186 5.80802 109.337 7.15274C126.744 12.824 142.694 9.49138 160.101 6.86039C170.88 5.22333 189.379 1.36455 198.556 8.32205C188.578 9.78371 179.255 11.4208 169.641 14.1103C162.213 16.215 154.784 18.6706 146.991 19.4891C137.596 20.4831 127.69 20.3077 118.514 18.4952C113.78 17.5598 109.337 15.3965 104.676 14.6364C90.4007 12.1224 75.2517 19.8984 60.9039 19.7815C55.0046 19.7815 44.444 16.8582 49.3237 10.6607C42.9874 8.26359 34.0291 10.2515 27.547 11.1285C20.1182 12.1224 12.9079 13.6425 5.84324 15.6303C5.84324 16.3904 5.84324 17.1505 5.84324 17.969C14.7287 16.4489 23.7598 15.5135 32.8637 15.3965C35.4129 15.3965 37.962 15.455 40.5111 15.3965C44.881 15.3965 42.8417 15.1626 44.8081 17.092C46.9931 19.3137 48.5225 20.0153 52.0913 20.6585C63.453 22.6463 75.9801 20.1323 87.4146 19.5476C100.816 18.9045 112.906 21.477 126.161 22.354C151.361 24.0495 176.196 16.1565 200.813 13.1163C214.287 11.4792 228.344 10.6023 242.4 10.7192C241.599 10.8361 240.798 10.953 239.997 11.07C234.899 11.8885 229.873 13.0579 225.066 14.6949C219.458 16.5658 214.87 19.4307 208.898 20.3662C195.715 22.4709 182.096 23.6402 168.767 25.2773C155.148 26.9728 141.31 29.253 127.545 29.4869C114.362 29.7208 102.272 27.0898 89.4539 25.2189C77.291 23.4649 66.0749 23.7572 54.0577 26.0374C47.7214 27.2652 41.3851 28.7853 34.903 29.3115C28.1297 29.8962 21.3564 28.9022 14.6559 28.6099C11.5969 28.493 8.61083 28.5514 5.62474 28.7268C5.5519 33.1703 5.40625 37.8476 5.40625 42.3495C7.29987 42.1156 9.12065 41.8233 11.0143 41.6479C14.2917 41.2386 18.8073 40.1862 22.1575 40.9463L21.939 41.1802Z",
    fill: "url(#paint1_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M264.328 56.6734C264.328 55.2702 264.983 54.0424 265.93 52.9315C265.93 52.5807 265.93 52.2299 265.93 51.8791C252.747 55.2702 238.4 57.4334 225.29 58.6612C213.273 59.7721 202.057 60.0644 191.132 55.2117C196.012 48.3711 226.382 44.6293 233.593 49.5405C231.772 51.4699 226.091 53.3408 224.416 54.3932C230.242 53.867 242.187 52.9315 246.12 49.1312C238.108 43.5769 219.827 45.2724 210.287 46.3833C199.799 47.5526 180.935 49.8912 173.652 56.381C176.784 60.1813 181.737 61.9938 186.252 64.3324C171.249 59.012 157.556 55.9717 141.388 55.0947C124.564 54.2178 107.084 53.1654 90.2601 54.627C81.666 55.3871 73.0718 56.381 64.4777 56.9072C59.7436 57.1996 54.6454 57.9596 49.9842 56.9072C46.4155 56.1472 43.7935 54.2178 40.5161 52.99C30.3197 49.1897 16.6274 50.9436 5.26562 53.6331C5.26562 54.1008 5.26562 54.627 5.26562 55.0947C11.0922 54.2762 16.9187 53.5746 22.818 53.2823C27.6977 53.0484 32.7231 52.99 37.4572 54.2762C40.8074 55.1532 43.2837 57.0826 46.4155 58.2519C51.7322 60.2398 57.9957 59.4797 63.6765 59.1289C72.4163 58.6612 81.0833 57.9012 89.7503 57.5504C106.065 56.9657 122.087 60.0644 138.183 61.8184C133.813 62.1107 129.443 62.2277 124.928 61.9353C116.115 61.3507 107.376 60.0644 98.4901 60.2983C89.6774 60.5322 81.0105 61.8184 72.2707 62.6954C60.8361 63.8063 50.5669 63.5139 39.4236 61.3506C31.9948 59.889 24.3475 58.135 16.6273 59.1874C12.6944 59.7136 9.1257 60.9999 5.77544 62.5785C5.77544 62.9877 5.84828 63.397 5.92111 63.8063C11.9661 61.4091 18.2296 59.7721 25.3671 60.4152C34.2526 61.1753 42.6282 64.0986 51.5865 64.8587C69.4302 66.4373 86.9098 61.2922 104.826 62.6369C113.202 63.28 121.286 65.0341 129.516 66.1449C138.11 67.3143 146.413 67.2558 155.08 66.905C164.475 66.5542 173.798 68.1328 183.048 69.1267C191.496 69.0682 199.726 68.9513 207.373 68.8928C207.956 68.7759 208.466 68.659 209.048 68.542C210.505 68.1912 211.306 67.0804 211.306 66.028C222.012 65.0925 232.355 63.397 243.061 61.9353C250.344 60.9414 257.627 60.0644 264.91 59.0705C264.546 58.3689 264.328 57.5504 264.4 56.7318L264.328 56.6734Z",
    fill: "url(#paint2_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M60.9058 20.6002C75.2536 20.6586 90.3298 12.941 104.678 15.4551C109.339 16.2736 113.782 18.4369 118.516 19.3139C127.765 21.1264 137.597 21.2433 146.993 20.3078C154.859 19.4893 162.215 17.0337 169.643 14.9289C179.257 12.2395 188.58 10.6024 198.557 9.14076C198.266 8.90689 197.829 8.67301 197.538 8.43915C187.997 9.90081 178.893 11.4794 169.643 14.0519C162.215 16.1567 154.786 18.6123 146.993 19.4308C137.597 20.4247 127.692 20.2493 118.516 18.4369C113.782 17.5014 109.339 15.3382 104.678 14.5781C90.4026 12.064 75.2536 19.8401 60.9058 19.7232C56.1718 19.7232 48.5973 17.8522 48.0875 13.9934C47.5048 18.4369 55.8804 20.5417 60.9058 20.5417V20.6002Z",
    fill: "url(#paint3_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M56.8255 35.3921C67.6046 34.2228 81.8068 32.2349 92.2217 35.8014C92.513 35.5675 92.6587 35.3921 92.8043 35.1582C82.3166 31.2995 67.7503 33.4043 56.8255 34.5736C52.1643 35.0998 38.2535 38.2569 35.0489 33.872C34.9032 33.872 34.7576 33.872 34.5391 33.8135C36.4327 39.4847 51.8002 35.9768 56.7527 35.4506L56.8255 35.3921Z",
    fill: "url(#paint4_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M164.031 52.1134C165.123 50.944 161.991 50.944 161.482 49.2485C161.482 49.4239 161.409 49.6578 161.482 49.8332C161.627 51.1779 163.375 51.5287 164.031 52.0549V52.1134Z",
    fill: "url(#paint5_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M52.8193 49.0732C53.0378 48.6639 53.4748 48.1377 54.2759 47.4362C57.4805 44.6298 65.8562 43.402 70.4445 42.7004C70.226 42.4665 69.9347 42.2326 69.6434 41.9988C64.9822 42.7588 57.3349 43.9282 54.3488 46.6176C52.8921 47.9039 52.4551 48.664 52.8921 49.1317L52.8193 49.0732Z",
    fill: "url(#paint6_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M226.596 54.16C229 53.1076 232.277 51.7629 233.661 50.3597C233.515 50.2428 233.297 50.1258 233.079 50.0089C230.821 51.7629 226.014 53.3999 224.484 54.3354C225.14 54.2769 225.868 54.2185 226.596 54.16Z",
    fill: "url(#paint7_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M39.346 62.1701C50.4892 64.3918 60.7585 64.6841 72.1931 63.5148C80.9329 62.6378 89.5998 61.3515 98.4124 61.1177C107.298 60.8838 116.038 62.17 124.85 62.7547C129.366 63.047 133.736 62.9301 138.106 62.6378C136.358 62.4624 134.61 62.2285 132.862 62.0531C130.24 62.1116 127.545 62.0531 124.777 61.9362C115.965 61.3515 107.225 60.0653 98.3396 60.2991C89.527 60.533 80.86 61.8192 72.1202 62.6962C60.6857 63.8071 50.4164 63.5147 39.2732 61.3515C31.8444 59.8898 24.1971 58.1359 16.4769 59.1883C12.544 59.7145 8.97525 61.0007 5.625 62.5793C5.625 62.8717 5.625 63.1055 5.69783 63.3978C9.04809 61.8193 12.544 60.5915 16.4769 60.0653C24.1971 58.9544 31.8444 60.7084 39.2732 62.2285L39.346 62.1701Z",
    fill: "url(#paint8_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M40.5864 53.8677C43.8638 55.0955 46.5586 57.0249 50.0545 57.785C54.6429 58.7789 59.814 58.0188 64.548 57.785C73.215 57.2588 81.7363 56.2648 90.3304 55.5047C107.154 54.0431 124.634 55.037 141.458 55.9725C157.627 56.8495 171.319 59.8897 186.322 65.2102C184.574 64.2747 182.754 63.4562 181.006 62.5792C168.042 58.3696 155.66 55.914 141.458 55.1539C124.634 54.2769 107.154 53.2245 90.3304 54.6862C81.7363 55.4463 73.1421 56.4402 64.548 56.9664C59.814 57.2587 54.7157 58.0188 50.0545 56.9664C46.4858 56.2063 43.8638 54.2769 40.5864 53.0491C30.39 49.2488 16.6977 51.0028 5.33594 53.6923C5.33594 53.9846 5.33594 54.2769 5.33594 54.5108C16.6977 51.8214 30.39 50.0089 40.5864 53.8677Z",
    fill: "url(#paint9_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M210.357 46.3258C199.869 47.4952 181.006 49.8339 173.723 56.3236C173.868 56.499 174.014 56.6159 174.16 56.7913C181.734 50.5939 200.088 48.3137 210.357 47.1444C219.679 46.092 237.305 44.4549 245.607 49.5415C245.826 49.3661 246.044 49.2492 246.19 49.0738C238.179 43.5195 219.898 45.215 210.357 46.3258Z",
    fill: "url(#paint10_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M254.565 35.9183C251.215 35.509 242.839 33.4627 237.668 33.3458C236.503 33.755 235.41 34.1643 234.391 34.5736C238.105 33.1119 250.341 36.2106 254.565 36.7368C258.498 37.263 262.285 37.4384 266.072 37.4969C266.072 37.2045 266.072 36.9122 266.072 36.6783C262.285 36.6199 258.425 36.4445 254.492 35.9183H254.565Z",
    fill: "url(#paint11_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M5.84375 16.4488C12.9084 14.461 20.1187 12.9993 27.5476 11.9469C33.8839 11.0699 42.5509 9.14051 48.8872 11.3038C49.0329 11.0699 49.1785 10.8361 49.397 10.6022C43.0607 8.20508 34.1024 10.1929 27.6204 11.0699C20.1916 12.0638 12.9812 13.584 5.91658 15.5718C5.91658 16.3319 5.91658 17.092 5.91658 17.9105C5.91658 17.3843 5.91658 16.8581 5.91658 16.3904L5.84375 16.4488Z",
    fill: "url(#paint12_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M191.709 55.4461C191.709 55.4461 191.345 55.8554 191.199 56.0893C202.124 60.942 213.34 60.6496 225.357 59.5387C238.467 58.3694 252.815 56.1477 265.997 52.8151C265.997 52.5228 265.997 52.2889 265.997 51.9966C252.815 55.3876 238.467 57.5509 225.357 58.7787C213.559 59.8311 202.488 60.1819 191.782 55.563L191.709 55.4461Z",
    fill: "url(#paint13_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M5.406 29.7798C8.31926 29.5459 11.3054 29.4875 14.4371 29.6629C21.1376 29.9552 27.9838 30.9491 34.6843 30.3645C41.1663 29.8383 47.5027 28.2597 53.839 27.0904C65.8562 24.8102 77.0723 24.5178 89.2352 26.2718C102.054 28.1427 114.144 30.7737 127.326 30.5399C141.091 30.306 154.929 28.0258 168.549 26.2718C181.877 24.5763 195.496 23.4654 208.679 21.3606C214.651 20.3667 219.312 17.5603 224.848 15.6894C229.654 14.1108 234.68 12.9415 239.778 12.0645C240.579 11.9476 241.38 11.8306 242.181 11.7137C240.506 11.7137 238.831 11.7137 237.229 11.7137C233.005 12.5322 228.853 13.5261 224.848 14.8709C219.24 16.7418 214.651 19.6067 208.679 20.5421C195.496 22.6469 181.877 23.8162 168.549 25.4533C154.929 27.1488 141.091 29.429 127.326 29.6629C114.144 29.8967 102.054 27.2658 89.2352 25.3948C77.0723 23.6408 65.8562 23.9332 53.839 26.2134C47.5027 27.4412 41.1663 28.9613 34.6843 29.4875C27.9109 30.0721 21.1376 29.0782 14.4371 28.7859C11.3782 28.6689 8.39209 28.7274 5.406 28.9028C5.33317 33.3463 5.1875 38.0236 5.1875 42.5255C5.1875 38.3159 5.33317 33.9309 5.406 29.7798Z",
    fill: "url(#paint14_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M6.0625 10.6025C18.8809 4.69739 33.4472 6.9191 47.7222 6.5683C59.1567 6.27597 70.2999 2.76799 81.5888 1.3648C86.6142 1.3648 91.7124 1.30632 96.9563 1.30632C98.0488 1.48172 99.1412 1.65711 100.234 1.89097C118.733 6.04208 134.537 9.60855 153.983 5.34051C159.227 4.17118 164.471 3.00183 169.642 1.89097C180.713 2.06637 191.492 2.30024 201.542 2.53411C202.344 2.24177 203.145 2.00793 203.946 1.77406C193.24 1.48173 181.659 1.24785 169.642 1.07245C164.398 2.24177 159.227 3.41112 153.983 4.52199C134.465 8.8485 118.733 5.22356 100.234 1.07245C99.1412 0.838582 98.0488 0.604726 96.9563 0.487793C91.7124 0.487793 86.6142 0.487805 81.5888 0.546272C70.2999 1.94946 59.1567 5.45744 47.7222 5.74977C33.4472 6.10057 18.8809 3.87882 6.0625 9.78392C6.0625 10.1932 6.0625 10.6025 6.0625 11.0702C6.0625 11.0702 6.0625 10.7779 6.0625 10.6609V10.6025Z",
    fill: "url(#paint15_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M232.498 30.5983C220.48 33.697 207.881 32.82 195.499 33.3462C185.886 33.7555 177.291 35.7433 168.479 38.5497C159.812 41.2392 151.655 45.5656 142.041 45.5072C133.301 45.4487 125.071 42.5839 116.331 41.9992C112.18 41.7069 86.2519 44.981 84.1398 41.5899C84.1398 41.473 84.0669 41.3561 83.9941 41.2976C83.8485 41.6484 83.8485 42.0577 84.1398 42.4669C86.2519 45.858 112.18 42.5839 116.331 42.8762C125.071 43.4609 133.301 46.3257 142.041 46.3842C151.655 46.4427 159.812 42.1161 168.479 39.4267C177.291 36.6788 185.886 34.6324 195.499 34.2232C207.881 33.697 220.48 34.574 232.498 31.4753C242.694 28.8443 253.036 26.6226 263.67 25.3363C264.471 25.2194 265.272 25.1609 266.073 25.044C266.073 25.6871 266.073 26.2717 266.073 26.9149C266.073 25.9794 266.073 25.1025 266.073 24.167C265.272 24.2839 264.398 24.4008 263.67 24.4593C253.036 25.7456 242.694 27.9673 232.498 30.5983Z",
    fill: "url(#paint16_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M197.902 4.98926C210.794 7.73718 223.758 4.46307 236.94 4.81387C246.627 5.1062 256.313 5.86628 265.927 6.97714C265.927 8.49727 265.927 11.1867 266 14.5777C266 10.7774 265.927 7.79567 265.927 6.15862C256.313 5.04775 246.627 4.28768 236.94 3.99534C224.195 3.64455 211.668 6.62632 199.14 4.34613C198.704 4.52153 198.267 4.7554 197.902 4.98926Z",
    fill: "url(#paint17_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M199.285 4.40503C200.741 3.7619 202.344 3.17723 204.019 2.7095C203.145 2.7095 202.198 2.70953 201.251 2.65106C200.013 3.11879 198.848 3.58649 197.828 4.17116C198.265 4.28809 198.775 4.34657 199.212 4.4635L199.285 4.40503Z",
    fill: "url(#paint18_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M237.959 33.4049C246.335 30.5401 256.459 28.4353 266.072 27.8506V26.9152C255.075 27.5583 243.349 30.2477 234.391 33.8142C235.192 33.4634 236.503 33.4049 238.032 33.4634L237.959 33.4049Z",
    fill: "url(#paint19_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M83.9948 41.2976C84.9416 39.1928 92.0063 37.965 92.8074 36.0941C92.5889 36.0356 92.3704 35.9772 92.1519 35.8602C89.8942 37.5558 83.048 38.842 84.0677 41.2976H83.9948Z",
    fill: "url(#paint20_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M208.171 27.032C195.425 28.4936 182.607 29.7214 169.862 31.0077C156.679 32.3524 143.496 34.2233 130.241 34.5741C117.933 34.9249 105.915 32.2354 93.8982 30.2476C81.444 28.2013 69.6453 27.5582 57.1911 29.7799C50.0536 31.0662 41.9693 34.2233 34.6133 32.9371C34.7589 33.3463 34.9774 33.6971 35.1959 33.9895C42.4062 35.0419 50.1992 32.0601 57.1911 30.7738C69.6453 28.4936 81.444 29.1952 93.8982 31.2416C105.915 33.2294 117.933 35.9189 130.241 35.5681C143.496 35.2173 156.752 33.2879 169.862 32.0016C182.607 30.7153 195.425 29.546 208.171 28.0259C219.096 26.7396 228.272 21.4192 238.979 19.2559C247.864 17.4435 256.895 16.2742 265.999 15.5726C265.999 15.2218 265.999 14.9294 265.999 14.6371C256.895 15.3387 247.864 16.508 238.979 18.3205C228.2 20.4837 219.096 25.8627 208.171 27.0904V27.032Z",
    fill: "url(#paint21_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M55.5872 50.7689C57.845 51.0028 60.9039 49.775 63.0889 49.3073C68.4056 48.1964 73.7223 47.3194 79.1846 46.6763C88.3614 45.6239 97.5382 45.507 106.715 45.8578C119.096 46.3255 130.458 49.6581 142.402 51.9383C146.7 52.7568 158.717 56.1478 162.795 53.8676C164.543 52.9322 164.543 52.4645 163.961 52.1137C163.742 52.3475 163.378 52.5814 162.795 52.9322C158.717 55.1539 146.7 51.8213 142.402 51.0028C130.458 48.7226 119.096 45.4485 106.715 44.9223C97.4654 44.5715 88.3614 44.6884 79.1846 45.7408C73.7223 46.3839 68.4056 47.261 63.0889 48.3718C60.9039 48.8395 57.845 50.0673 55.5872 49.8335C54.1306 49.6581 53.1838 49.4242 52.8196 49.0734C52.1641 50.1258 53.1837 50.4766 55.5872 50.7689Z",
    fill: "url(#paint22_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M174.232 56.8495C174.232 56.8495 173.868 57.1419 173.723 57.2588C175.543 59.4221 177.874 60.9422 180.423 62.2869C182.39 62.9301 184.356 63.5732 186.323 64.2748C182.025 62.053 177.437 60.2991 174.232 56.8495Z",
    fill: "url(#paint23_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M226.961 54.1602C225.941 54.6279 224.994 55.0372 224.484 55.3295C230.311 54.7448 242.255 53.8679 246.188 50.0676C245.97 49.9506 245.751 49.7752 245.533 49.6583C241.673 52.5816 232.86 53.5755 226.961 54.1602Z",
    fill: "url(#paint24_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M233.005 50.126C233.005 50.126 233.514 49.7168 233.66 49.5414C226.377 44.6302 196.006 48.3721 191.199 55.2126C191.418 55.3296 191.636 55.388 191.782 55.4465C197.973 49.2491 224.993 45.9165 233.005 50.0676V50.126Z",
    fill: "url(#paint25_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M54.4955 8.32249C63.0896 7.56243 71.3196 5.16534 79.7681 3.87908C85.4489 3.00209 91.2026 2.59282 96.8106 3.87908C101.181 4.87301 105.186 6.80237 109.338 8.1471C126.744 13.8183 142.695 10.4858 160.101 7.8548C170.443 6.2762 187.85 2.70973 197.318 8.55636C197.755 8.4979 198.119 8.43944 198.556 8.38097C189.38 1.42347 170.88 5.28225 160.101 6.91931C142.695 9.5503 126.744 12.9414 109.338 7.21166C105.113 5.80847 101.181 3.93753 96.8106 2.9436C91.2026 1.65734 85.4489 2.0666 79.7681 2.9436C71.3196 4.22986 63.0896 6.62699 54.4955 7.38705C38.3997 8.84871 20.9201 4.75608 6.0625 11.012C6.0625 11.3043 6.0625 11.6551 6.0625 12.0059C20.993 5.69154 38.4725 9.78415 54.5683 8.32249H54.4955Z",
    fill: "url(#paint26_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M264.835 59.0715C257.552 60.0655 250.269 60.9425 242.986 61.9364C232.207 63.3981 221.865 65.0351 211.231 66.029C211.231 67.0814 210.43 68.1923 208.974 68.5431C208.391 68.66 207.881 68.777 207.298 68.8939C199.651 69.0108 191.494 69.0693 182.973 69.1278C173.723 68.0754 164.328 66.4968 155.005 66.906C146.338 67.2568 138.036 67.3153 129.441 66.146C121.212 65.0351 113.127 63.2811 104.752 62.638C86.9078 61.2933 69.3554 66.3799 51.5117 64.8597C42.6262 64.0997 34.2506 61.1763 25.2923 60.4163C18.1548 59.8316 11.8913 61.4102 5.84627 63.8073C5.84627 63.6904 5.84627 63.6319 5.84627 63.515H5.77344C5.77344 63.9827 5.84627 64.392 5.9191 64.7428C11.9641 62.3457 18.2276 60.7086 25.3651 61.3517C34.2506 62.1118 42.6262 65.0351 51.5845 65.7952C69.4282 67.3738 86.9078 62.2287 104.824 63.5735C113.2 64.2166 121.284 65.9706 129.514 67.0814C138.108 68.2508 146.411 68.1923 155.078 67.8415C164.473 67.4907 173.796 69.0693 183.045 70.0632C191.494 70.0048 199.724 69.8878 207.371 69.8294C207.954 69.7124 208.464 69.5955 209.046 69.4786C210.503 69.1278 211.304 68.0169 211.304 66.9645C222.01 66.0291 232.352 64.3335 243.059 62.8719C250.56 61.8779 257.989 60.9425 265.418 59.9485C265.2 59.6562 265.054 59.3639 264.908 59.0715H264.835Z",
    fill: "url(#paint27_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M266.072 44.8051C265.489 44.6297 264.98 44.5712 264.761 44.5127C257.769 43.8696 250.34 45.6821 243.494 44.2789C238.178 43.2265 234.463 41.3555 228.709 40.8878C214.216 39.7769 199.504 39.8354 185.083 41.6479C181.587 42.0572 160.976 44.2789 161.486 49.0147C161.486 49.1316 161.486 49.2485 161.559 49.307C162.87 45.0389 181.733 43.0511 185.083 42.5833C199.504 40.7709 214.216 40.7124 228.709 41.8233C234.39 42.2326 238.178 44.1035 243.494 45.2144C250.34 46.6175 257.769 44.8051 264.761 45.4482C264.98 45.4482 265.489 45.5651 266.072 45.7405C266.072 43.1095 266.072 40.3616 266.072 37.6137C266.072 40.0108 266.072 42.4664 266.072 44.8051Z",
    fill: "url(#paint28_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M37.4494 55.2123C40.7996 56.0893 43.2759 58.0187 46.4076 59.188C51.7244 61.1759 57.9879 60.4158 63.6687 60.065C72.4085 59.5973 81.0755 58.8372 89.7424 58.4864C104.017 57.9602 118.074 60.2989 132.13 62.0528C134.17 62.0528 136.136 61.9359 138.175 61.7605C122.08 60.065 106.057 56.9078 89.7424 57.4925C81.0027 57.8433 72.3357 58.5448 63.6687 59.071C57.9879 59.3634 51.7972 60.1819 46.4076 58.1941C43.2759 57.0248 40.7996 55.0954 37.4494 54.2184C32.7153 52.9321 27.7628 52.9905 22.8102 53.2244C16.9108 53.5167 11.0843 54.2184 5.25781 55.0369C5.25781 54.8615 5.25781 54.6861 5.25781 54.5692C5.25781 55.0369 5.25781 55.5631 5.25781 56.0308C11.0843 55.2123 16.9108 54.5107 22.8102 54.2184C27.6899 53.9845 32.7153 53.926 37.4494 55.2123Z",
    fill: "url(#paint29_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M21.9388 42.1158C24.852 42.8174 26.7456 44.9222 29.8774 45.5068C38.69 47.2024 61.632 36.4446 69.425 41.9989C69.7891 41.9989 70.0804 41.8819 70.3718 41.8235C63.6713 34.5152 39.0542 46.3254 29.8774 44.5129C26.7456 43.9283 24.852 41.8235 21.9388 41.1219C18.5885 40.3618 14.073 41.4142 10.7955 41.8235C8.90191 42.0573 7.08112 42.2912 5.1875 42.5251C5.1875 42.8174 5.1875 43.1682 5.1875 43.4605C7.08112 43.2267 8.90191 42.9343 10.7955 42.759C14.073 42.3497 18.5885 41.2973 21.9388 42.0573V42.1158Z",
    fill: "url(#paint30_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M48.0789 14.1692C48.2245 13.4091 48.5887 12.5906 49.2442 11.6551C49.0985 11.5967 48.88 11.5382 48.7343 11.4797C48.1517 12.4737 47.9332 13.3507 48.0789 14.1692Z",
    fill: "url(#paint31_linear_4948_66295)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M40.4413 16.3904C44.8112 16.3904 42.7719 16.1565 44.7383 18.0859C46.9233 20.3077 48.4527 21.0093 52.0215 21.6524C63.3832 23.6402 75.9102 21.1262 87.3448 20.5415C100.746 19.8984 112.836 22.4709 126.091 23.3479C151.291 25.0434 176.126 17.1505 200.744 14.1102C212.397 12.6486 224.487 11.83 236.65 11.7131C237.742 11.4792 238.835 11.3038 239.927 11.1284C240.728 11.0115 241.529 10.8946 242.33 10.7776C228.347 10.6607 214.29 11.5377 200.744 13.1747C176.126 16.215 151.291 24.108 126.091 22.4124C112.909 21.5354 100.746 18.9629 87.3448 19.606C75.9102 20.1322 63.3832 22.7048 52.0215 20.7169C48.4527 20.0738 46.9233 19.3722 44.7383 17.1505C42.7719 15.2211 44.7383 15.3965 40.4413 15.4549C37.8922 15.4549 35.3431 15.338 32.794 15.4549C23.69 15.5719 14.6589 16.5658 5.77344 18.0275C5.77344 18.3783 5.77344 18.6706 5.77344 18.9629C14.6589 17.4428 23.69 16.5073 32.8668 16.3904C35.4159 16.3904 37.965 16.4489 40.5141 16.3904H40.4413Z",
    fill: "url(#paint32_linear_4948_66295)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_4948_66295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2617 44.7769L72.8906 26.2828C72.791 26.0504 72.7135 25.8013 72.6582 25.5357C72.6029 25.259 72.5752 24.9823 72.5752 24.7056C72.5752 23.9198 72.8464 23.2668 73.3887 22.7466C73.931 22.2265 74.6117 21.9664 75.4307 21.9664C76.0283 21.9664 76.5153 22.149 76.8916 22.5142C77.279 22.8684 77.6331 23.4771 77.9541 24.3404L83.0508 38.0699L87.7822 24.5396C88.1032 23.5767 88.4684 22.9071 88.8779 22.5308C89.2874 22.1545 89.8298 21.9664 90.5049 21.9664C91.335 21.9664 91.988 22.1933 92.4639 22.647C92.9398 23.1008 93.1777 23.7206 93.1777 24.5064C93.1777 24.8163 93.1445 25.1373 93.0781 25.4693C93.0228 25.7903 92.9342 26.1057 92.8125 26.4156L85.6738 44.5611C85.3529 45.3801 84.9766 45.9667 84.5449 46.3209C84.1133 46.675 83.5599 46.8521 82.8848 46.8521C82.2539 46.8521 81.7337 46.6916 81.3242 46.3707C80.9258 46.0497 80.5716 45.5185 80.2617 44.7769ZM100.399 42.7681C100.399 44.0852 100.173 45.0647 99.7188 45.7066C99.265 46.3485 98.5732 46.6695 97.6436 46.6695C96.7139 46.6695 96.0221 46.3485 95.5684 45.7066C95.1146 45.0647 94.8877 44.0852 94.8877 42.7681V25.8013C94.8877 24.4843 95.1146 23.5048 95.5684 22.8629C96.0221 22.2099 96.7139 21.8834 97.6436 21.8834C98.5732 21.8834 99.265 22.2099 99.7188 22.8629C100.173 23.5048 100.399 24.4843 100.399 25.8013V42.7681ZM115.457 47.0845C111.904 47.0845 109.043 45.9169 106.874 43.5816C104.705 41.2352 103.62 38.1418 103.62 34.3013C103.62 30.5494 104.743 27.4836 106.99 25.1041C109.237 22.7134 112.081 21.5181 115.523 21.5181C117.549 21.5181 119.259 21.9055 120.653 22.6802C122.059 23.455 122.762 24.357 122.762 25.3863C122.762 26.0504 122.529 26.6314 122.064 27.1295C121.6 27.6275 121.052 27.8765 120.421 27.8765C120.067 27.8765 119.347 27.7216 118.263 27.4117C117.189 27.0907 116.287 26.9302 115.557 26.9302C113.753 26.9302 112.308 27.6109 111.224 28.9722C110.15 30.3225 109.613 32.1431 109.613 34.4341C109.613 36.6809 110.161 38.4628 111.257 39.7798C112.364 41.0858 113.852 41.7388 115.723 41.7388C116.586 41.7388 117.571 41.5341 118.678 41.1246C119.785 40.704 120.515 40.4937 120.869 40.4937C121.434 40.4937 121.943 40.7372 122.396 41.2242C122.85 41.7112 123.077 42.2701 123.077 42.9009C123.077 44.0409 122.341 45.0259 120.869 45.856C119.408 46.675 117.604 47.0845 115.457 47.0845ZM128.423 27.3287H126.397C125.069 27.3287 124.084 27.1184 123.442 26.6978C122.8 26.2772 122.479 25.6408 122.479 24.7886C122.479 23.9143 122.8 23.2668 123.442 22.8463C124.095 22.4146 125.08 22.1988 126.397 22.1988H135.977C137.283 22.1988 138.262 22.4146 138.915 22.8463C139.568 23.2668 139.895 23.9143 139.895 24.7886C139.895 25.6408 139.568 26.2772 138.915 26.6978C138.273 27.1184 137.294 27.3287 135.977 27.3287H133.935V42.7681C133.935 44.0852 133.708 45.0647 133.254 45.7066C132.8 46.3485 132.108 46.6695 131.179 46.6695C130.249 46.6695 129.557 46.3485 129.104 45.7066C128.65 45.0647 128.423 44.0852 128.423 42.7681V27.3287ZM146.17 34.3677C146.17 36.6255 146.707 38.4351 147.78 39.7964C148.854 41.1467 150.276 41.8218 152.047 41.8218C153.818 41.8218 155.24 41.1467 156.313 39.7964C157.387 38.4351 157.924 36.6255 157.924 34.3677C157.924 32.0325 157.393 30.1786 156.33 28.8062C155.268 27.4338 153.84 26.7476 152.047 26.7476C150.254 26.7476 148.826 27.4338 147.764 28.8062C146.701 30.1786 146.17 32.0325 146.17 34.3677ZM140.177 34.3013C140.177 30.483 141.267 27.4006 143.447 25.0543C145.639 22.6968 148.505 21.5181 152.047 21.5181C155.6 21.5181 158.472 22.6968 160.663 25.0543C162.854 27.4117 163.95 30.494 163.95 34.3013C163.95 38.1308 162.854 41.2186 160.663 43.565C158.483 45.9114 155.611 47.0845 152.047 47.0845C148.483 47.0845 145.611 45.9114 143.431 43.565C141.261 41.2186 140.177 38.1308 140.177 34.3013ZM172.55 36.8248V42.7681C172.55 44.0852 172.323 45.0647 171.869 45.7066C171.415 46.3485 170.724 46.6695 169.794 46.6695C168.864 46.6695 168.173 46.3485 167.719 45.7066C167.265 45.0647 167.038 44.0852 167.038 42.7681V26.067C167.038 24.595 167.32 23.5823 167.885 23.0289C168.449 22.4755 169.434 22.1988 170.84 22.1988H175.123C177.99 22.1988 180.242 22.8795 181.88 24.2408C183.518 25.591 184.337 27.4283 184.337 29.7525C184.337 31.4791 183.822 32.9234 182.793 34.0855C181.775 35.2366 180.364 35.967 178.56 36.2769L182.909 41.108C183.463 41.7167 183.872 42.2867 184.138 42.8179C184.414 43.3381 184.553 43.8196 184.553 44.2623C184.553 44.9927 184.304 45.607 183.806 46.105C183.308 46.6031 182.682 46.8521 181.93 46.8521C181.443 46.8521 180.972 46.7027 180.519 46.4039C180.076 46.105 179.561 45.5959 178.975 44.8765L172.55 36.8248ZM172.55 33.1392H175.09C176.208 33.1392 177.071 32.8791 177.68 32.3589C178.288 31.8388 178.593 31.1028 178.593 30.1509C178.593 29.2323 178.294 28.524 177.696 28.0259C177.099 27.5168 176.252 27.2623 175.156 27.2623H172.55V33.1392ZM198.349 23.9254C198.813 23.2613 199.3 22.7522 199.81 22.398C200.319 22.0328 200.817 21.8502 201.304 21.8502C201.912 21.8502 202.466 22.0992 202.964 22.5972C203.462 23.0953 203.711 23.6431 203.711 24.2408C203.711 24.927 203.329 25.8069 202.565 26.8804L202.449 27.0298L196.871 34.982V42.7681C196.871 44.0852 196.644 45.0647 196.19 45.7066C195.737 46.3485 195.05 46.6695 194.132 46.6695C193.202 46.6695 192.51 46.3485 192.057 45.7066C191.603 45.0647 191.376 44.0852 191.376 42.7681V34.982L185.798 27.0963C185.798 27.0963 185.787 27.0797 185.765 27.0464C184.968 25.9397 184.569 25.0266 184.569 24.3072C184.569 23.6431 184.824 23.0731 185.333 22.5972C185.842 22.1213 186.473 21.8834 187.226 21.8834C187.679 21.8834 188.133 22.0549 188.587 22.398C189.041 22.7411 189.528 23.2724 190.048 23.9918L194.165 29.8853L198.349 23.9254Z",
    fill: "#531300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_4948_66295",
    x: 72.5742,
    y: 21.5181,
    width: 131.137,
    height: 26.447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.880557
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.32549 0 0 0 0 0.0313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4948_66295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4948_66295",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.76111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4948_66295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4948_66295",
    x1: 134.831,
    y1: -6.76169,
    x2: 136.145,
    y2: 93.2838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4948_66295",
    x1: 135.629,
    y1: 3.99558,
    x2: 135.629,
    y2: 63.5143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4948_66295",
    x1: 135.634,
    y1: 3.99517,
    x2: 135.634,
    y2: 63.5139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4948_66295",
    x1: 123.322,
    y1: 9.14074,
    x2: 123.322,
    y2: 19.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4948_66295",
    x1: 63.6717,
    y1: 33.1119,
    x2: 63.6717,
    y2: 36.6784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4948_66295",
    x1: 162.865,
    y1: 49.4239,
    x2: 162.865,
    y2: 51.8795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4948_66295",
    x1: 61.4863,
    y1: 42.3496,
    x2: 61.4863,
    y2: 48.4886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4948_66295",
    x1: 229.073,
    y1: 50.2428,
    x2: 229.073,
    y2: 54.0431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4948_66295",
    x1: 71.9746,
    y1: 59.1298,
    x2: 71.9746,
    y2: 63.7486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4948_66295",
    x1: 95.7928,
    y1: 51.529,
    x2: 95.7928,
    y2: 63.9239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4948_66295",
    x1: 209.993,
    y1: 45.7996,
    x2: 209.993,
    y2: 55.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4948_66295",
    x1: 250.268,
    y1: 33.5796,
    x2: 250.268,
    y2: 37.2045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4948_66295",
    x1: 27.5476,
    y1: 9.95906,
    x2: 27.5476,
    y2: 17.2674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4948_66295",
    x1: 228.562,
    y1: 52.3474,
    x2: 228.562,
    y2: 59.5388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4948_66295",
    x1: 123.757,
    y1: 13.2338,
    x2: 123.757,
    y2: 40.0699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4948_66295",
    x1: 105.041,
    y1: 1.01399,
    x2: 105.041,
    y2: 10.1347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4948_66295",
    x1: 174.961,
    y1: 25.2779,
    x2: 174.961,
    y2: 44.5133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4948_66295",
    x1: 231.915,
    y1: 4.52154,
    x2: 231.915,
    y2: 13.7007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4948_66295",
    x1: 199.649,
    y1: 33.5795,
    x2: 198.334,
    y2: 83.0609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4948_66295",
    x1: 250.049,
    y1: 34.9251,
    x2: 248.688,
    y2: 84.4083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4948_66295",
    x1: 88.656,
    y1: 30.5398,
    x2: 87.3414,
    y2: 79.9632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4948_66295",
    x1: 149.978,
    y1: 32.2355,
    x2: 148.617,
    y2: 81.6602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4948_66295",
    x1: 109.337,
    y1: 31.1242,
    x2: 107.975,
    y2: 80.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4948_66295",
    x1: 181.224,
    y1: 33.0538,
    x2: 179.863,
    y2: 82.4784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4948_66295",
    x1: 236.137,
    y1: 34.5739,
    x2: 234.776,
    y2: 83.9987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4948_66295",
    x1: 213.194,
    y1: 33.9308,
    x2: 211.88,
    y2: 83.3543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4948_66295",
    x1: 101.399,
    y1: 30.8906,
    x2: 100.037,
    y2: 80.3154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4948_66295",
    x1: 136.797,
    y1: 31.8261,
    x2: 135.483,
    y2: 81.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4948_66295",
    x1: 214.362,
    y1: 33.9888,
    x2: 213,
    y2: 83.4135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4948_66295",
    x1: 72.9183,
    y1: 30.1302,
    x2: 71.5567,
    y2: 79.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4948_66295",
    x1: 38.3259,
    y1: 29.1948,
    x2: 37.0112,
    y2: 78.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4948_66295",
    x1: 47.9332,
    y1: 29.4289,
    x2: 46.6185,
    y2: 78.8521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4948_66295",
    x1: 123.324,
    y1: 31.4747,
    x2: 121.962,
    y2: 80.8993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdogwuVictoryBtn);
export default __webpack_public_path__ + "static/media/odogwu-victory-btn.0e5eee714c3a4b76bb3d89e7079b13e1.svg";
export { ForwardRef as ReactComponent };